/* --------------------------------------------------------------------------------------
   workflowScanning.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class workflowScanningService {
  submitScanTicket (ticket, deviceUrl) {
    return new Promise(function(resolve, reject) {
      submitScanTicket(
        deviceUrl,
        ticket,
        null,
        120,
        (env, response) => resolve({env, response}),
        (env, response, status) => reject({method: 'Submit Scan', env, response, status})
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/workflowScanning.service.js